import axios from 'axios';
import { aadConfig, getAccessToken } from '../aad';
import type { ProjectCounts } from '../dto/project';
import apiProxy from './apiProxy';

export const getProjectCounts = apiProxy(
  'getProjectCounts',
  async (accountId: string, officeIds?: string[], providerId?: string): Promise<ProjectCounts[]> => {
    await getAccessToken(aadConfig().projectScopes);

    const q: string[] = [`accounts=${accountId}`];
    if (providerId) q.push(`providerId=${providerId}`);
    if (officeIds) q.push(`offices=${encodeURIComponent(officeIds.join(','))}`);

    const { data } = await axios.get<ProjectCounts[]>(
      `${process.env.PROJECT_API}/statistics/project-counts?${q.join('&')}`,
    );
    if (data.length) return data;

    return [
      {
        accountId,
        providerId: providerId || accountId,
        total: 0,
        draft: 0,
        submitted: 0,
        accepted: 0,
        feeReady: 0,
        feeCounter: 0,
        approved: 0,
        inProgress: 0,
        complete: 0,
        canceled: 0,
        rejected: 0,
      },
    ];
  },
);

export const getMonthlyProjectCounts = apiProxy(
  'getMonthlyProjectCounts',
  async (accountId: string, providerId?: string, year?: number, month?: number): Promise<ProjectCounts[]> => {
    await getAccessToken(aadConfig().projectScopes);

    const q: string[] = [`accounts=${accountId}`];
    if (providerId) q.push(`providerId=${providerId}`);
    if (year && month) {
      q.push(`year=${year}`);
      q.push(`month=${month}`);
    }

    const { data } = await axios.get<ProjectCounts[]>(
      `${process.env.PROJECT_API}/statistics/monthly-project-counts?${q.join('&')}`,
    );
    if (data.length) return data;

    return [
      {
        accountId,
        providerId: providerId || accountId,
        total: 0,
        draft: 0,
        submitted: 0,
        accepted: 0,
        feeReady: 0,
        feeCounter: 0,
        approved: 0,
        inProgress: 0,
        complete: 0,
        canceled: 0,
        rejected: 0,
      },
    ];
  },
);
